module.exports = __webpack_public_path__ + "static/media/night.9f7ef16d.svg";